import routes from "@/constants/routes";
import getConfig from "next/config";
import Link from "next/link";

const { publicRuntimeConfig } = getConfig();

const ContactBanner = (): JSX.Element => {
  return (
    <section className="relative z-30 flex flex-col items-center justify-center w-auto text-white rounded-2xl bg-landing-denim mx-4 md:mx-5 lg:mx-20 py-7 md:py-9 lg:py-16 mt-8 md:mt-4">
      <h2 className="text-3xl font-bold text-center xl:text-5xl max-w-[300px] md:max-w-fit">
        Get started with Keyzy
      </h2>

      <div className="flex flex-col items-center justify-center text-center md:mt-5 md:flex-row">
        <p className="my-6 font-serif text-xl font-normal whitespace-nowrap md:my-auto xl:text-2xl">
          Get in touch:{" "}
          <span className="underline">
            <a href="mailto:hello@keyzy.com" target="_blank" rel="noreferrer">
              hello@keyzy.com
            </a>
          </span>
        </p>

        <div className="hidden w-px h-12 bg-white md:mx-4 xl:mx-12 md:inline-block" />

        <p className="font-serif text-xl font-normal xl:text-2xl">Or sign up to Keyzy here</p>

        <Link href={routes.register}>
          <a className="min-w-[8rem] flex items-center justify-center w-full h-12 px-4 py-3 mt-4 text-base font-bold transition duration-300 ease-in-out transform rounded-md whitespace-nowrap md:mt-0 md:w-auto bg-landing-orange md:ml-4 xl:ml-9 hover:scale-105 text-white">
            Sign up today!
          </a>
        </Link>
      </div>
    </section>
  );
};

export default ContactBanner;
